export default __webpack_public_path__ + "locales/vi/InviteDialog.json?hash=f7b7bd3bb3fd847f251b524d3a15a32a";